import { useNavigate } from "react-router-dom";
import Button from "@/shared/components/Button";

const KycVerification = () => {
  const navigate = useNavigate();

  return (
    <div className="relative z-10 w-full max-w-md px-6">
      <div className="mb-8 flex justify-center">
        <img src="/logo_kyc.png" alt="kyc" className="h-[360px] w-[337px]" />
      </div>
      <div className="mx-auto space-y-4 text-center text-white">
        <h1 className="text-2xl font-semibold">Complete Your KYC</h1>
        <p className="text-sm text-white/70">
          We partner with trusted providers to verify your identity. The
          verification takes just a few minutes and unlocks full access to your
          Nommia membership benefits.
        </p>
        <Button
          variant="primary"
          fluid
          onClick={() => navigate("/kyc-verification/form")}>
          Start KYC Verification
        </Button>
        <p className="text-xs text-white/60">
          We&apos;ll collect a few personal details before redirecting you to
          the verification provider.
        </p>
      </div>
    </div>
  );
};

export default KycVerification;
